import { ComponentType, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import AuthContext from '.';
import LoadingSpinner from '../LoadingSpinner';

const withAuthenticationRequired = <P extends object>(
    Component: ComponentType<P>
): React.FC<P> => {
    return function WithAuthenticationRequired(props: P): JSX.Element {
        const { isAuthenticated, isLoading } = useContext(AuthContext);
        const history = useHistory();

        useEffect(() => {
            if (isLoading || isAuthenticated) return;

            history.push('/login?ref=' + window.location.href);
        }, [isLoading, isAuthenticated]);

        return isAuthenticated ? <Component {...props} /> : <LoadingSpinner />;
    };
};

export default withAuthenticationRequired;
